<template>
    <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
        <el-table-column prop="indicatorItems_" label="指标项" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column
            prop="assessmentObjectives_"
            label="指标考核目标"
            :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="weight" label="权重"></el-table-column>
        <el-table-column prop="indicatorCompletion_" label="指标完成"></el-table-column>
        <el-table-column prop="indicatorCompletionScore" label="指标得分" width="100">
            <template slot-scope="scope">
                <span
                    v-if="EXTRA_ITEMS.includes(scope.row.indicatorItems)"
                    :class="scope.row.indicatorItems === EXTRA_ITEMS[0] ? 'red-score' : 'green-score'">
                    {{ scope.row.indicatorCompletionScore }}
                </span>
                <span
                    v-else-if="TRANS_RANGE_ITEMS.includes(scope.row.indicatorItems)"
                    :class="+scope.row.indicatorCompletionScore < 0 ? 'red-score' : 'green-score'">
                    {{ scope.row.indicatorCompletionScore }}
                </span>
                <span
                    v-else
                    :class="+scope.row.indicatorCompletionScore < +scope.row.weight ? 'red-score' : 'green-score'">
                    {{ scope.row.indicatorCompletionScore }}
                </span>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api'
const TRANS_RANGE_ITEMS = ['5', '6'] // 5'运力线上化率', 6'运力稳定率'
const DEDUCT_ITEM = '7' // 减分项（客户投诉）
const BONUS_ITEM = '8' // 加分项（客户表扬）
const EXTRA_ITEMS = [DEDUCT_ITEM, BONUS_ITEM]
export default {
    data() {
        return {
            EXTRA_ITEMS,
            TRANS_RANGE_ITEMS,
            tableData: [],
            loading: true,
            dictData: {},
        }
    },
    methods: {
        reset(){
            this.tableData = []
            this.loading = true
        },
        async init(list = []) {
            await dictWithUrl('SUPPLIER_INDICATOR_ITEMS_TYPE')
                .then(res => {
                    if (res && +res.code === 0) {
                        this.dictData = res.data
                    }
                })
                .catch(err => {})
            this.tableData = list.map(item => {
                item.indicatorItems_ = this.dictData.SUPPLIER_INDICATOR_ITEMS_TYPE[item.indicatorItems]
                if (EXTRA_ITEMS.includes(item.indicatorItems)) {
                    item.assessmentObjectives_ = '-'
                    item.indicatorCompletion_ = '-'
                    item.weight = '-'
                } else {
                    item.assessmentObjectives_ = item.assessmentObjectives + (['12', '13'].includes(item.indicatorItems)?'':'%')
                    item.indicatorCompletion_ = item.indicatorCompletion + (['12', '13'].includes(item.indicatorItems)?'':'%')
                }
                return item
            })
            this.loading = false
        },
    },
}
</script>
<style lang="less" scoped>
.red-score {
    color: red;
}

.green-score {
    color: green;
}
</style>